export const paths = {
  login: "/",
  home: "/approveDecline",
  agreement: "/agreement",
  document: "/document",
  homeLanding: "/home",
  jobOpenings: "/job-opening",
  interviews: "/interviews",
  profile: "/profile",
  addProfile: "/add-profile", //Late we can remove it
  createProfile: "/create-profile",
  jobDetails: "/job-details/:id",
};
